import { render } from "./AdminWithdrawManagement.vue?vue&type=template&id=c497d6a2&scoped=true"
import script from "./AdminWithdrawManagement.vue?vue&type=script&lang=js"
export * from "./AdminWithdrawManagement.vue?vue&type=script&lang=js"

import "./AdminWithdrawManagement.vue?vue&type=style&index=0&id=c497d6a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c497d6a2"]])

export default __exports__